import axios from 'axios';
import noop from 'lodash/noop';
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import urlJoin from 'url-join';

import { useConfig } from '../config';
import useInterval from '../use-interval';

export default function useActionNotifier() {
  const { api, sessionPollSecs } = useConfig();
  const [isActivity, setIsActivity] = useState(false);

  const notify = async () => {
    setIsActivity(false);
    const sessionCheckUrl = urlJoin(api, 'session');
    await axios.post(sessionCheckUrl, null, { withCredentials: true });
  };

  useIdleTimer({
    timeout: 2_147_483_646,
    onAction: () => setIsActivity(true),
    onIdle: noop,
    debounce: 500,
    events: [
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mouseWheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
    ],
  });

  useInterval(async () => {
    if (isActivity) {
      await notify();
    }
  }, sessionPollSecs * 1000);
}
